import {Pipe, PipeTransform} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {convertCommercialUnit, convertDentsToWidthInMeter, TranslateService, Unit} from '@vdw/angular-component-library';
import {CalculateDimensionsBasePipe} from '../calculate-dimensions-base-pipe';

@Pipe({
  name: 'calculateDimensionsOfProductionScheduleColoredYarnSet'
})
export class CalculateDimensionsOfProductionScheduleColoredYarnSetPipe extends CalculateDimensionsBasePipe implements PipeTransform {
  public constructor(translate: TranslateService) {
    super(translate);
  }

  public transform(
    productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet,
    displayTechnicalUnit: boolean,
    commercialUnit: Unit,
    productionSchedule: ProductionSchedule
  ): string {
    let dimension = 0;

    if (displayTechnicalUnit) {
      dimension = productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet.technicalWidthInDents;
    } else {
      dimension = convertCommercialUnit({
        from: {
          unit: Unit.METER,
          value: convertDentsToWidthInMeter(productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet.technicalWidthInDents, productionSchedule.machineQuality.reedDensity * 1000)
        },
        to: Unit.MILLIMETER
      });
    }

    return `${this.calculateDimensions(dimension, displayTechnicalUnit, commercialUnit)} ${this.getUnitLabel(displayTechnicalUnit, Unit.DENTS, commercialUnit)}`;
  }
}
